import { SubMenu } from "./SubMenu";
import { MenuItem } from "./MenuItem";

export const Menu = ({ selectIteam, items, onClick }) => {
    const renderMenuItems = (menuItems) => {
        return menuItems.map((item) => {
            const isActive = selectIteam === item.label;


            if (item.children) {
                return (
                    <SubMenu key={item.key} label={item.label} icon={item.icon}>
                        {renderMenuItems(item.children)}
                    </SubMenu>
                );
            } else {
                return <MenuItem key={item.key} label={item.label} icon={item.icon} onClick={() => onClick(item)} isActive={isActive} />;
            }
        });
    };

    return <nav className="text-white general-menu relative px-1 scroll-project-details">{renderMenuItems(items)}</nav>;
};
